import classnames from 'classnames';

import classes from './mainPageLayout.module.css';

type MainPageLayoutProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const Page = ({ children, className, style }: MainPageLayoutProps) => {
  return (
    <div className={classnames(classes.page, className)} style={style}>
      {children}
    </div>
  );
};

const Header = ({ children, className, style }: MainPageLayoutProps) => (
  <div className={classnames(classes.header, className)} style={style}>
    {children}
  </div>
);

const Main = ({ children, className, style }: MainPageLayoutProps) => (
  <main className={classnames(classes.main, className)} style={style}>
    {children}
  </main>
);

const MainContent = ({ children, className, style }: MainPageLayoutProps) => (
  <div className={classnames(classes.mainContent, className)} style={style}>
    {children}
  </div>
);

export const MainPageLayout = {
  Page,
  Header,
  Main,
  MainContent,
};
